import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GroupIcon from "@diligentcorp/atlas-react-icons/Group.js";
import { Avatar, Chip, InputAdornment, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { OptionType, } from "../../shared/presets/autocomplete.js";
import { getUserAvatarProps } from "./helpers/userLookup.js";
export const autocompletePresets = (tokens) => {
    const groupAvatar = (_jsx(Avatar, Object.assign({ sx: { color: tokens.semantic.color.text.body.value } }, { children: _jsx(GroupIcon, {}) })));
    return {
        userLookup: {
            type: {
                single: {
                    getStartAdornment: (value) => (_jsx(InputAdornment, Object.assign({ position: "start" }, { children: _jsx(Avatar, Object.assign({}, (value.type === OptionType.user
                            ? getUserAvatarProps(value.label, tokens)
                            : {
                                children: _jsx(GroupIcon, {}),
                            }))) }))),
                },
                multiple: {
                    renderTags: (value, getTagProps) => value.map((option, index) => (_createElement(Chip, Object.assign({}, getTagProps({ index }), { key: option.id, avatar: option.type === OptionType.user ? (_jsx(Avatar, Object.assign({}, getUserAvatarProps(option.label, tokens)))) : (groupAvatar), label: option.label })))),
                },
            },
            getGroupBy: ({ users, groups }) => (option) => {
                if (option.type === OptionType.user)
                    return users;
                return groups;
            },
            renderOption: (props, option) => option.type === OptionType.user ? (_jsxs(ListItem, Object.assign({}, props, { children: [_jsx(ListItemIcon, { children: _jsx(Avatar, Object.assign({}, getUserAvatarProps(option.label, tokens))) }), _jsx(ListItemText, { disableTypography: false, primary: option.label, secondary: option.email })] }))) : (_jsxs(ListItem, Object.assign({}, props, { children: [_jsx(ListItemIcon, { children: groupAvatar }), _jsx(ListItemText, { disableTypography: false, primary: option.label })] }))),
        },
    };
};
//# sourceMappingURL=autocomplete.js.map